import { Component } from '@angular/core';
import { SocialAiReusePostFormComponent } from '../../components/forms/social-ai-reuse-post-form/social-ai-reuse-post-form.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-social-ai-reuse',
  standalone: true,
  imports: [SocialAiReusePostFormComponent],
  templateUrl: './social-ai-reuse.component.html',
  styleUrl: './social-ai-reuse.component.scss'
})
export class SocialAiReuseComponent {

  constructor(private router: Router, private location: Location) { }

  backToPrevPage() {
    this.location.back();
  }

}
